import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class FullFooter extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <span>CIC - Desenvolvido por:</span>
        <img src='https://s3.us-east-2.amazonaws.com/explorelabs/IconeExploreLabs.ico' style={{width: 30, height: 30}} alt='ExploreLabs'></img>
        <span>ExploreLabs. Sistemas & Consultoria </span>
      </React.Fragment>
    );
  }
}

FullFooter.propTypes = propTypes;
FullFooter.defaultProps = defaultProps;

export default FullFooter;
